export default {
  title: 'THE PAGE YOU’RE LOOKING FOR MUST BE HERE SOMEWHERE...',
  description: 'Are you looking for one of the pages below?',
  not_found: "We can't find the url you entered. Please check if it was entered correctly.",
  toasts: {
    failed_to_load_stores: 'Failed to load stores, please refresh the page',
  },
};
